import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

function FireIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="4 -4 21.198 33.242" width="24" height="25" {...props}>
      <path
        d="M12.959 0a.5.5 0 0 0-.41.457c-.313 3.507-2.34 5.822-4.4 8.217S4 13.573 4 17.332a7.707 7.707 0 0 0 2.665 5.9 7.76 7.76 0 0 0 4.905 2 .5.5 0 1 0 0-1.009 6.9 6.9 0 0 1-4.243-1.751 6.647 6.647 0 0 1-2.319-5.142c0-3.389 1.859-5.625 3.911-8.012 1.895-2.2 3.888-4.572 4.464-7.949 7.644 5.361 10.8 10.81 10.8 14.9 0 3.892-2.376 7.025-4.732 7.981a.51.51 0 0 0 .379.946c2.833-1.149 5.363-4.631 5.363-8.927 0-4.728-3.58-10.569-11.861-16.182A.51.51 0 0 0 13.006 0ZM14.9 7.775a.5.5 0 0 0-.442.584 17.269 17.269 0 0 1 .284 4.337 4.07 4.07 0 0 1-.662 2.161.675.675 0 0 1-.946.189 4.453 4.453 0 0 1-1.672-1.688.5.5 0 0 0-.4-.227.509.509 0 0 0-.418.2c-1.883 2.539-1.8 4.57-1.136 5.883a4.767 4.767 0 0 0 1.83 1.924.5.5 0 1 0 .473-.883 3.741 3.741 0 0 1-1.4-1.483c-.457-.909-.578-2.271.694-4.258a4.571 4.571 0 0 0 1.64 1.467 1.8 1.8 0 0 0 2.1-.457 4.841 4.841 0 0 0 .915-2.744 16.228 16.228 0 0 0-.11-3.06A10.48 10.48 0 0 1 18.558 14.1a6.994 6.994 0 0 1-1.341 6.293.508.508 0 0 0 .82.6 8.1 8.1 0 0 0 1.5-7.161 12.372 12.372 0 0 0-4.258-5.946A.506.506 0 0 0 14.9 7.775Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </SvgIcon>
  );
}

export default FireIcon;
